import apiService from '@/services/apiService'

// Job scheduler mínimo — ver SPEC/PLAN/TASKS_JOBS_PROGRAMADOS_v0.1.md en
// ventax-subs-api/docs.
export default {
  async getJobs() {
    const { data } = await apiService.get('/api/maintenance/jobs')
    return data.data
  },
  async updateJob(clave, payload) {
    const { data } = await apiService.put(`/api/maintenance/jobs/${clave}`, payload)
    return data.data
  },
  async runJob(clave) {
    const { data } = await apiService.post(`/api/maintenance/jobs/${clave}/run`)
    return data.data
  },
}
